import { useHistory, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCandidateInfo } from "../../API/Candidates/Cadidate";
import WelcomeFirstLogin from "./welcomeFirstLogin/welcomeFirstLogin";
import Step1FirstLogin from "./step1/step1";
import Step2FirstLogin from "./step2/step2";
import Step3FirstLogin from "./step3/step3";
import Loading from "../../Components/Loading/Loading";

import "./firstLogin.sass";
import InfoFirstLogin from "./infoFirstLogin/infoFirstLogin";

const FirstLogin = () => {
  const history = useHistory();
  const [currentStep, setCurrentStep] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [registrationStage, setRegistrationStage] = useState("");

  const registrationStageToStep = {
    PersonalInfo: 2,
    ProfessionalExperience: 3,
    Salary: 4,
  };

  const steps = [
    <WelcomeFirstLogin onNextStep={() => setCurrentStep(currentStep + 1)} />,
    <InfoFirstLogin onNextStep={() => setCurrentStep(currentStep + 1)} />,
    <Step1FirstLogin onNextStep={() => setCurrentStep(currentStep + 1)} />,
    <Step2FirstLogin onNextStep={() => setCurrentStep(currentStep + 1)} />,
    <Step3FirstLogin onNextStep={() => setCurrentStep(currentStep + 1)} />,
  ];

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const user = await getCandidateInfo(localStorage.getItem("candidateId"));
      setRegistrationStage(user.item.registration_stage);

      if (user.item.registration_stage === "Finished") {
        history.push("/candidate");
        return;
      }

      if (user.item.registration_stage === null || !user.item.registration_stage) {
        setCurrentStep(0);
        setIsLoading(false);
      } else {
        setCurrentStep(registrationStageToStep[user.item.registration_stage]);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleNextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  return (
    <>
      <div className="bg-purple-candidate">
        {isLoading ? <Loading /> : <div className="content d-flex flex-column  justify-content-center w-100 p-5">{steps[currentStep]}</div>}
      </div>
    </>
  );
};

export default FirstLogin;
